import React from 'react';

import ErrorAlertIcon from 'components/Shared/Icons/ErrorAlertIcon';
import LabeledInput from 'components/Shared/Inputs/LabeledInput';
import Spinner from 'components/Shared/Spinner/Spinner';
import { colors } from 'styles/cp';

type InputWithErrorProps = {
  label: React.ReactNode;
  type: string;
  name: string;
  value?: string;
  error: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  onFocus?: () => void;
  placeholder?: string;
  cdn?: string;
  countryField?: Record<string, any>;
  updateCountry?: Function;
  isLoading?: boolean;
  disabled?: boolean;
};

const LabeledInputWithErrors: React.FC<InputWithErrorProps> = ({
  label,
  type,
  name,
  value,
  error,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  cdn,
  countryField,
  updateCountry,
  isLoading = false,
  disabled = false,
}) => {
  const handleLabelClick = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  return (
    <div>
      <div className="input-container" onClick={handleLabelClick}>
        <LabeledInput
          label={label}
          type={type}
          name={name}
          value={value}
          isInError={!!error}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          placeholder={placeholder}
          countryField={countryField}
          cdn={cdn}
          updateCountry={updateCountry}
          disabled={disabled}
        />
        {isLoading && (
          <div className="input-spinner">
            <Spinner width={16} strokeWidth={6} color={colors.green} />
          </div>
        )}
      </div>
      {!!error && (
        <div className="error-notice">
          <span className="error-icon">
            <ErrorAlertIcon height={16} width={16} />
          </span>
          <span>{error}</span>
        </div>
      )}
      <style jsx>{`
        .input-container {
          position: relative;
        }

        .error-notice {
          padding-top: 8px;
          color: ${colors.darkError};
          font-size: 12px;
          display: flex;
          align-content: center;

          .error-icon {
            padding-right: 4px;
          }
        }

        .input-spinner {
          position: absolute;
          right: 12px;
          top: 64%;
          transform: translateY(-50%);
          pointer-events: none;
          z-index: 1;
        }
      `}</style>
    </div>
  );
};

export default LabeledInputWithErrors;
